import React, { useEffect, useRef, useState } from 'react';

function AudioPlayer() {
  const [toggle, setToggle] = useState(true);
  const audioRef = useRef();

  useEffect(() => {
    const playAudio = () => {
      audioRef.current?.play().catch((error) => {
        console.error('Autoplay was prevented: ', error);
      });
    };
    // Add a temporary click event listener to start audio playback
    const handleClick = () => {
      playAudio();
      document.removeEventListener('click', handleClick);
    };
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

  return (
    toggle && (
      <>
        <audio ref={audioRef} loop src='/bg.mp4' style={{ display: 'none' }} />
        <button onClick={() => setToggle(!toggle)}>🔇</button>
      </>
    )
  );
}

export default AudioPlayer;
